import { useEffect, useState } from 'react';

const useDebouncedEffect = (effect: () => (void | Promise<void>), delay: number, deps: any[]) => {
	const [computing, setComputing] = useState(0);
	useEffect(() => {
		let disposed = false;
		let called = false;
		setComputing((n) => n + 1);
		const timeout = setTimeout(async () => {
			called = true;
			await effect();
			if (!disposed) {
				setComputing((n) => n - 1);
			}
		}, delay);
		return () => {
			if (called) return;
			disposed = true;
			setComputing((n) => n - 1);
			clearTimeout(timeout);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [...deps]);
	return computing > 0;
}

export default useDebouncedEffect;
